module.exports = __webpack_public_path__ + "assets/56ddbe1e119db3c02da97dc04012cf2b.js";